import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { mapFramesizeFacetToLabelKeys } from "@grandvisionhq/utils";
import { TileLayout } from "../../../../../TileLayout/modules/EcommContent/components/TileLayout/TileLayout.js";
const FrameSizeText = ({ facetTerm }) => {
  const { getLabel } = useIntl();
  const keys = mapFramesizeFacetToLabelKeys(facetTerm);
  const title = getLabel(keys?.title || "") || `${facetTerm}`;
  const subtitle = getLabel(keys?.subtitle || "");
  return /* @__PURE__ */ React.createElement(TileLayout, { title, subtitle });
};
export {
  FrameSizeText
};
//# sourceMappingURL=FrameSizeText.js.map
